import classNames from '../../utils/classNames'
import { numberWithCommas } from '../../utils/number'
import type { AmountInputProps } from '../wallet-management/amount-input'

interface AmountSelectorProps
  extends Pick<AmountInputProps, 'amount' | 'setAmount'> {
  amounts: number[]
}

const AmountSelector = ({
  amount,
  setAmount,
  amounts,
}: AmountSelectorProps) => {
  return (
    <div className="flex gap-2.5 lg:gap-[20px_15px] justify-center flex-wrap mb-5 lg:mb-[30px]">
      {amounts.map((item, index) => (
        <button
          onClick={() => setAmount(item)}
          className={classNames(
            'w-[calc((100vw-76px)/3)] lg:w-[calc((100%-30px)/3)] bg-tertiary py-1.5 lg:py-3 text-base lg:text-lg text-txt font-Avenir-Light',
            '!border border-white dark:border-white rounded-[19px] lg:rounded-[26px] transition-all duration-200 ease-in-out cursor-pointer',
            amount === item ? 'opacity-100' : 'opacity-70',
          )}
          key={index}>
          $ {numberWithCommas(item)}
        </button>
      ))}
    </div>
  )
}

export default AmountSelector
